<template>
  <section class="newsletter">
    <div>
      <h2 style="margin-bottom:8px;">Ready to Get Our New Stuff?</h2>
      <div>Stay updated with sales and new arrivals.</div>
    </div>
    <form style="display:flex;align-items:center;">
      <input type="email" placeholder="Your Email" />
      <button type="submit">Subscribe</button>
    </form>
  </section>
</template>
